import React from 'react';
import { motion } from 'framer-motion';
interface PageHeaderProps {
  title: string;
  breadcrumb: string;
  onNavigateHome: () => void;
}
export function PageHeader({
  title,
  breadcrumb,
  onNavigateHome
}: PageHeaderProps) {
  return <div className="relative bg-gradient-to-br from-brand-navy to-[#0a1d3d] pt-32 pb-16 overflow-hidden" data-id="element-285">
      {/* Subtle dot pattern overlay */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-286"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-287">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-5xl font-extrabold text-white mb-4" data-id="element-288">
          {title}
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex items-center justify-center text-sm font-medium text-white/70 space-x-2" data-id="element-289">
          <button onClick={onNavigateHome} className="hover:text-brand-red transition-colors cursor-pointer" data-id="element-290">
            Home
          </button>
          <span data-id="element-291">/</span>
          <span className="text-white" data-id="element-292">{breadcrumb}</span>
        </motion.div>
      </div>
    </div>;
}